import React from "react";
import { Button } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { useStockStatisticModel } from "../stockStatisticModel";
import { formatNum } from "@/utils/utils";

export const DataBox = () => {
    const { statistics, exportStockStatistic } = useStockStatisticModel();

    const desc: IDescription[] = [
        {
            label: "库存数量",
            value: statistics?.totalInventoryNum ?? (statistics?.stockNum ?? 0),
            color: DescriptionColorEnum.red
        },
        {
            label: "库存金额",
            value: `${formatNum(statistics?.totalInventoryAmount ?? statistics?.stockAmount)}`,
            color: DescriptionColorEnum.red
        }
    ]

    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => exportStockStatistic()}
        >导出</Button>
    </>;

    return (
        <YhBox title="库存统计列表" descriptions={desc} action={action}>
            <DataTable />
        </YhBox>
    )
}